import React from "react";
import Photobooth from "./components/Photobooth";
import './App.css';
import "./styles/global.css"
const logoSrc = "/assets/logo/jiggleduo-logo.png";

function App() {
  return (
    <div className="App">
      <header className="app-header">
        <img className="app-logo" src={logoSrc} alt="JiggleDuo Logo" />
        <h1 className="app-title">
          Maulzz Photobooth
        </h1>
      </header>

      <main className="app-main">
        <Photobooth />
      </main>

    </div>
  );
}

export default App;
